import React from "react";

import { HeaderBreadcrumb } from "../../../common/ui/layout/header/header-breadcrumb/HeaderBreadcrumb";
import { PageHeader } from "../../../common/ui/layout/header/PageHeader";
import { ordersRoutes } from "../../OrdersRoutes";

export const OrderRequestDashboardHeader = (): JSX.Element => {
    return (
        <PageHeader>
            <HeaderBreadcrumb routes={ordersRoutes} />
        </PageHeader>
    );
};
